export enum Status {
    OK,
    WARNING,
    ERROR,
}
